<template>

  <v-toolbar light flat>

    <v-snackbar
      absolute
      :timeout="10000"
      :top="true"
      :multi-line="true"
      :vertical="false"
      v-model="snackbar"
    >
      Date ranges can be no more than {{maxDays}} days. Adjust your dates.
      <v-btn flat color="blue" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->

    <v-toolbar-title class="mr-5">
      Choose Date Range
    </v-toolbar-title>

    <v-toolbar-items>

      <v-menu lazy :close-on-content-click="true" transition="scale-transition" offset-y>
        <v-text-field
          light
          slot="activator"
          label="Start Date"
          v-model="start"
          prepend-icon="event"
          readonly
        />
        <v-date-picker v-model="start">
        </v-date-picker>
      </v-menu>

      <v-menu lazy :close-on-content-click="true" transition="scale-transition" offset-y>
        <v-text-field
          light
          slot="activator"
          label="End Date"
          v-model="end"
          prepend-icon="event"
          readonly
        />
        <v-date-picker v-model="end">
        </v-date-picker>
      </v-menu>

    </v-toolbar-items>

    <v-spacer/>

    <v-btn outline color="black" light icon @click="changeDay(-1)">
      <v-icon>remove</v-icon>
    </v-btn>

    <v-btn outline color="black" light icon @click="changeDay(1)" :disabled="endRangeOverExtends(1)">
      <v-icon>add</v-icon>
    </v-btn>

    <v-btn outline small color="black" @click="setToday()">
      Select Today
    </v-btn>

  </v-toolbar>

</template>

<script>
  import DateRange from '@/models/DateRange';

  export default {

    name: 'DateRangeBar',

    data() {
      return {
        range: new DateRange(this.$route.query.startDate, this.$route.query.endDate),
        maxDays: 366,
        snackbar: false,
      };
    },

    mounted() {
      this.$store.commit('SET_DATE_RANGE', new DateRange(this.range.startIso, this.range.endIso));
    },

    watch: {

      range: {
        deep: true,
        handler(range) {
          // push the existing route to the router,
          // but adjust the query params for start and end dates
          this.$router.push({
            ...this.$route,
            query: {
              startDate: range.startIso,
              endDate: range.endIso,
            },
          });
          if (this.range.numOfDays > this.maxDays) {
            this.snackbar = true;
          } else {
            this.$store.commit('SET_DATE_RANGE', new DateRange(this.range.startIso, this.range.endIso));
          }
        },
      },

    },

    computed: {

      start: {
        get() {
          return this.range.startIso;
        },
        set(newIso) {
          this.range.setFromIso({
            start: newIso,
            end: this.range.endIso,
          });
        },
      },

      end: {
        get() {
          return this.range.endIso;
        },
        set(newIso) {
          this.range.setFromIso({
            start: this.range.startIso,
            end: newIso,
          });
        },
      },

    },

    methods: {

      setToday() {
        this.range.setToday();
      },

      changeDay(num) {
        if (!this.endRangeOverExtends(num)) {
          this.range.interval = this.range.interval.set({
            start: this.range.start.plus({ days: num }),
            end: this.range.end.plus({ days: num }),
          });
        }
      },

      endRangeOverExtends(n) {
        return DateRange.dateExtendsPastToday(this.range.end.plus({ days: n }));
      },

    },

  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DateRangeBar.vue